import _ from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { buildDescriptionSeo } from '../../../utils/buildMetadata';
import { isGigApproved } from '../../../utils/gigStatus';
import { sanitizeSeo } from '../utils';
import {
    GENERAL_SCHEMA,
    IN_STOCK,
    OUT_OF_STOCK,
    BRAND,
    FIVERR
} from '../constants';

export const shouldFormatSeo = (seo) => seo && !_.isEmpty(seo.schemaMarkup);

export const formatSeo = ({ seo, pathfinderWrapper, packagesCount, general }) => {
    const { pathParameters, locale } = getContext();
    const { schemaMarkup, description } = seo;
    const { username, slug } = pathParameters;
    const { gigStatus, subCategoryId } = general;
    const availability = isGigApproved(gigStatus) ? IN_STOCK : OUT_OF_STOCK;
    const descriptionSeo = buildDescriptionSeo(description, locale, subCategoryId);

    const formattedSeo = {
        '@context': GENERAL_SCHEMA,
        '@type': schemaMarkup.type,
        name: schemaMarkup.gigTitle,
        image: schemaMarkup.gigImage,
        brand: {
            '@type': BRAND,
            name: FIVERR
        },
        description: descriptionSeo
    };

    const gigRatings = schemaMarkup.gigRatings,
        gigOffers = schemaMarkup.gigOffers;

    if (gigRatings) {
        formattedSeo.aggregateRating = {
            '@type': gigRatings.type,
            ratingValue: gigRatings.value,
            reviewCount: gigRatings.count,
            bestRating: gigRatings.best,
            worstRating: gigRatings.worst
        };
    }

    if (gigOffers) {
        formattedSeo.offers = {
            '@type': gigOffers.type,
            url: pathfinderWrapper.pathfinder('gig_page', { username, slug }, { absolute: true }),
            price: gigOffers.price,
            lowPrice: gigOffers.lowPrice,
            highPrice: gigOffers.highPrice,
            priceCurrency: gigOffers.currency,
            offerCount: packagesCount,
            availability: `${GENERAL_SCHEMA}${availability}`
        };
    }

    return sanitizeSeo(formattedSeo);
};
